import React, {Dispatch, SetStateAction, useEffect, useState} from 'react';

import {useTranslation} from "react-i18next";
import AccordionItem from 'components/blocks/Accordion/AccordionItem';
import Accordion from 'components/blocks/Accordion';
import {AddIterationsRefereeModal} from "../RefereesSection/AddItrationsRefereeModal";
import {CourseOrderLocalItemResult} from "../../../../../../../../services/courseOrder/models/CourseOrderType";
import RefereesSection from "../RefereesSection";

function RefereeIterationSections({
                                       order,
                                       setTriggerOrderUpdate,
                                   }: {
    order: CourseOrderLocalItemResult | null;
    setTriggerOrderUpdate: Dispatch<SetStateAction<boolean>>;
}) {
    const iterations = order?.courseOrderRefereeIterations ?? [];
    const [isAddIterationModalOpened, setIsAddIterationModalOpened] = useState(false);
    const [activeId, setActiveId] = useState(iterations.length ? iterations[0].id : 0);
    const activeIteration = 
        iterations.find((it) => it.id === activeId) ?? null;
    useEffect(() => {
        if (iterations.length ) {
            setActiveId(iterations[iterations.length-1].id );
        }
        
    }, [order]);
    
    const {t} =  useTranslation("Orders");
    return (
        <Accordion>
            <AccordionItem initiallyOpen title={t("referees")} elementId={13}>
        <div className="d-flex flex-column gap-3">

            <div className="d-flex justify-content-between">
                <div className="d-flex flex-wrap gap-2 justify-content-start">
                    {iterations.map((it, idx) => (
                        <button
                            key={it.id ?? idx}
                            type="button"
                            className={`btn ${activeId === it.id ? 'btn-primary fw-bold' : 'btn-outline-primary'} rounded-4 px-3 py-2`}
                            onClick={() => setActiveId(it.id)}
                            title={it.iteration.toString()}
                        >
                            {`${t('Iteration')} ${it.iteration}`}
                        </button>
                    ))}

                    {/* If no iterations, we still show a disabled placeholder */}
                    {iterations.length === 0 && (
                        <span className="text-muted small">{t('noIterationFound')}</span>
                    )}
                </div>
                <div>
                <button
                    type="button"
                    className="btn btn-outline-secondary  px-4"
                    onClick={() => {
                        setIsAddIterationModalOpened(true)
                    }}
                >
                    {t("AddIteration")}
                </button>
                </div>
            </div>

            {/* Tabs only (based on programOrderItrations) */}
            <div className="mt-3">
                {iterations.length >0 && activeIteration &&    <RefereesSection
                    order={activeIteration}
                    orderFiles={order?.researcherAttachmentWithoutInfo}
                    currentOrder={order}
                     setTriggerOrderUpdate={setTriggerOrderUpdate}
                    // isReadonly={false}
                />
                }
            </div>
        </div>
                <AddIterationsRefereeModal props={
                    {
                        isOpen:isAddIterationModalOpened,
                        onClose:(shouldUpdateTable?: boolean) => {
                            setIsAddIterationModalOpened(false);
                             if (shouldUpdateTable && setTriggerOrderUpdate) {
                                setTriggerOrderUpdate(state=>!state);
                            }
                        },
                        selectedCourseOrderEvaluationId:order?.id ?? 0
                    }
                }/>
            </AccordionItem>
        </Accordion>
    );
}

export default RefereeIterationSections;